<template>
  <div></div>
</template>

<script>
export default {
  name: "BaiDuCallback",
  mounted() {
    this.load()
  },
  data() {
    return {
      loginUrl: '/api/baidu/login',
      registerUrl: '/api/baidu/register',
      bindingUrl: '/api/baidu/binding',
    }
  },
  methods: {
    load() {
      let code = this.$route.query.code
      if (code != null) {
        let type = localStorage.getItem('baidu_back')
        localStorage.removeItem('baidu_back')
        if (type === 'register') {
          this.register(code)
        } else {
          this.binding(code)
        }
      } else {
        this.$router.replace('/m_login')
      }
    },
    register(code) {
      let machineType = this.getMachineType()
      this.$ajax({
        method: 'get',
        url: this.loginUrl,
        params: {code: code, platformType: machineType}
      }).then((response) => {
        let responseData = JSON.parse(response.data['responseData']);
        let unionid = responseData['unionid']
        if (response.data.result) {
          localStorage.setItem('islogin', '1')
          localStorage.setItem('loginTime', new Date().getTime().toString())
          localStorage.setItem('account', unionid)
          localStorage.setItem('accountType', 'Baidu')
          localStorage.setItem('token', responseData['token'])
          localStorage.setItem('yhnm', responseData['yhnm'])
          this.$router.replace('/m_birthday')
        } else {
          if (response.data['errorCode'] === "UnRegistered") {
            this.$messagebox.confirm("您还未注册平台帐号，点击确定自动注册，是否继续?").then(action => {
              if (action === 'confirm') {
                this.$ajax({
                  method: 'get',
                  url: this.registerUrl,
                  params: {
                    access_token: responseData['access_token'],
                    unionid: unionid,
                    platformType: machineType
                  }
                }).then((response) => {
                  let responseData = JSON.parse(response.data['responseData']);
                  localStorage.setItem('islogin', '1')
                  localStorage.setItem('loginTime', new Date().getTime().toString())
                  localStorage.setItem('account', unionid)
                  localStorage.setItem('accountType', 'Baidu')
                  localStorage.setItem('token', responseData['token'])
                  localStorage.setItem('yhnm', responseData['yhnm'])
                  this.$router.replace('/m_birthday')
                }).catch(response => {
                  this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
                })
              } else {
                this.$router.replace('/m_login')
              }
            })
          } else
            this.$messagebox.alert(response.data.message, '服务器返回错误')
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    binding(code) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.bindingUrl,
        params: {
          code: code,
          yhnm: localStorage.getItem('yhnm'),
        },
        headers: {token: localStorage.getItem('token')}
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message)
        }
        this.$router.replace('/m_account_setting')
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    }
  }
}
</script>

<style scoped>

</style>
